// src/lib/axios.ts
import axios from "axios";

console.log("Initializing URL: ", import.meta.env.VITE_PUBLIC_HTTP_URL);
console.log("Initializing API with URL: ", import.meta.env.VITE_API_URL);

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Important for handling authentication cookies
});

// Add request interceptor for JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("API Request Error:", error);
    return Promise.reject(error);
  }
);

// Add response interceptor for handling authentication errors
api.interceptors.response.use(
  (response) => {
    // Log successful requests in development
    if (import.meta.env.DEV) {
      console.log(
        `🟢 API Success [${response.config.method?.toUpperCase()}] ${
          response.config.url
        }`
      );
    }
    return response;
  },
  async (error) => {
    // Log failed requests
    console.error("API Response Error:", error);

    // Skip auth redirect for login errors
    const isLoginRequest = error.config?.url?.includes("/auth/login");

    // Handle authentication errors (but not during login)
    if (error.response?.status === 401 && !isLoginRequest) {
      console.log(
        "401 error detected, redirecting to login (not during login process)"
      );
      localStorage.removeItem("token");
      window.location.href = "/login"; // Redirect to login if unauthorized
    }

    return Promise.reject(error);
  }
);

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add response interceptor for public API
publicApi.interceptors.response.use(
  (response) => {
    // Log successful requests in development
    if (import.meta.env.DEV) {
      console.log(
        `🟢 Public API Success [${response.config.method?.toUpperCase()}] ${
          response.config.url
        }`
      );
    }
    return response;
  },
  (error) => {
    // Log failed requests
    console.error("Public API Response Error:", error);
    return Promise.reject(error);
  }
);
